/* Fixed product savings, once per order. Shopify discounts remain the live authority. */
(function (root, factory) {
  'use strict';
  if (typeof module === 'object' && module.exports) module.exports = factory;
  else root.EKLAVIV_BUNDLE_PRICING = factory(root.EKLAVIV_BUNDLE_PLANS || {}, root.EKLAVIV_BUNDLE_ACTIVATION || {});
})(typeof window !== 'undefined' ? window : this, function createPricing(plans, activation) {
  'use strict';
  function quote(key, unitCents, quantity, currency) {
    quantity = Number(quantity);
    quantity = Number.isFinite(quantity) ? Math.max(1, Math.floor(quantity)) : 1;
    unitCents = Number(unitCents);
    const regularCents = unitCents * quantity;
    const plan = plans[key];
    const active = !!(plan && activation[key] === true && plan.currency === currency && plan.unitCents === unitCents && Number.isSafeInteger(regularCents) && regularCents >= 0);
    let savingCents = 0;
    let tierQuantity = 1;
    if (active) {
      Object.keys(plan.totals).forEach(function (tier) {
        const count = Number(tier);
        const total = plan.totals[tier];
        const saving = count * unitCents - total;
        if (count <= quantity && Number.isSafeInteger(total) && total > 0 && saving > savingCents) {
          savingCents = saving;
          tierQuantity = count;
        }
      });
    }
    return {quantity:quantity, regularCents:regularCents, totalCents:regularCents - savingCents, savingCents:savingCents, active:active, tierQuantity:tierQuantity};
  }
  return {quote:quote};
});
